/* unplugin-vue-components disabled */import { render } from "./boxiao.vue?vue&type=template&id=c77af954&scoped=true"
import script from "./boxiao.vue?vue&type=script&lang=js"
export * from "./boxiao.vue?vue&type=script&lang=js"

import "./boxiao.vue?vue&type=style&index=0&id=c77af954&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c77af954"]])

export default __exports__